import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Pièce jointe — trombone duotone */
export const AttachmentIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Trombone */}
      <path
        d="M16.5 8.5L9 16a4 4 0 0 0 5.7 5.7L21 15.4a6 6 0 0 0-8.5-8.5L4.6 14.8a8 8 0 0 0 11.3 11.3"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
        transform="translate(-1.5, -3.5)"
      />
      {/* Point d'accroche menthe */}
      <circle cx="17" cy="7" r="2" fill="var(--equiply-icon-bg)" />
    </svg>
  ),
);
AttachmentIcon.displayName = "AttachmentIcon";
